module.exports = __webpack_public_path__ + "static/media/p1000-tip-box-open.89b44514.svg";